import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LOCAL_STORAGE } from "../constants/local-storage.constants";
import { LocalStorageService } from "../services/local-storage.service";
import { SessionStorageService } from "../services/session-storage.service";
import { SESSION_STORAGE } from "../constants/session-storage.constants";

@Injectable({
  providedIn: "root",
})
export class RequestInterceptorService implements HttpInterceptor {
  constructor() {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // throw new Error('Method not implemented.');

    if(!request.url.includes("googleapis")){
      const sessionId = SessionStorageService.getValue(SESSION_STORAGE.SESSION_ID);
      const customerId = LocalStorageService.getValue(LOCAL_STORAGE.CUSTOMER_ID);
      const businessId = SessionStorageService.getValue(SESSION_STORAGE.BUSINESSID);
      if (sessionId) {
        request = request.clone({
          setHeaders: {
            SessionId: `${sessionId}`,
            CustomerId: `${customerId}`,
            BusinessId: `${businessId}`,
          },
        });
      }
  
      return next.handle(request);
    }
    else{
      const corsRequest = request.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': 'http://localhost:8100',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type',
        },
      });
  
      return next.handle(corsRequest);
    }
  }
}
